import * as actionTypes from "./actionTypes";

export const afterLogin = (data, navigate) => {
    return async (dispatch) => {
        localStorage.setItem("doe-gyandeep-authdata", JSON.stringify(data))
        localStorage.setItem("DOE-Gyandeep-Token", data.token)
        // navigate("/registration/student-details-two", "_self")
        dispatch(updateAuthData(data, data.token))
    };
};

export const onReload = () => {
    return async (dispatch) => {
        // dispatch(apiLoading())
        let tokenData = localStorage.getItem("DOE-Gyandeep-Token") ? localStorage.getItem("DOE-Gyandeep-Token") : null
        let token = localStorage.getItem("doe-gyandeep-authdata") ? JSON.parse(localStorage.getItem("doe-gyandeep-authdata")) : null
        if (token) {
            dispatch(updateAuthData(token, tokenData))
        }
    };
};


export const onLogout = (navigate) => {
    return (dispatch) => {
        localStorage.clear();
        dispatch(resetAuth());
        navigate("/");
    }
};



export const updateAuthData = (data, token) => {
    return {
        type: actionTypes.UPDATE_AUTH_DATA,
        payload: { data, token },
    };
};


export const resetAuth = (data) => {
    return {
        type: actionTypes.RESET,
    };
};

export const updateReducer = (key, data) => {
    return {
        type: actionTypes.UPDATE_REDUCER,
        payload: { key, data }
    };
};




